import { FadeUp, MaskedLines } from "@/components/motion";
import { CTAButton } from "@/components/CTA";

export default function FinalCTA() {
  return (
    <section className="relative py-36 lg:py-52 bg-abyss border-t border-silver/10 blueprint-grid overflow-hidden" data-testid="section-cta-final">
      <div className="relative mx-auto max-w-[1500px] px-6 lg:px-12 text-left">
        <FadeUp y={20}>
          <span className="font-mono text-[11px] tracking-[0.4em] text-glow/80 block mb-10">
            CUOTA MENSUAL · SIN SORPRESAS
          </span>
        </FadeUp>
        <h2 className="font-display font-800 uppercase leading-[0.95] tracking-tight text-[11vw] sm:text-7xl lg:text-8xl text-offwhite max-w-5xl">
          <MaskedLines
            mode="view"
            lines={[
              <span key="a">La próxima incidencia</span>,
              <span key="b">
                ya tiene <span className="font-cormorant normal-case font-medium text-metal">gestor.</span>
              </span>,
            ]}
          />
        </h2>
        <FadeUp delay={0.2} className="mt-10 max-w-xl text-mist leading-relaxed">
          Suscríbete y la próxima vez que algo falle en tu comercio, lo único que tendrás que hacer es
          notificarlo. Del resto se encarga Aprea.
        </FadeUp>
        <FadeUp delay={0.3} className="mt-12">
          <CTAButton testid="final-cta-alta" className="px-12 py-5 text-sm">
            DARME DE ALTA
          </CTAButton>
        </FadeUp>
      </div>
    </section>
  );
}
